















































































































/* eslint-disable max-len, object-curly-newline, no-bitwise, no-restricted-syntax, camelcase, no-use-before-define */
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Modify, { typeModify } from './Service/Modify';
import DoModify from './Service/DoModify';

/** 代替IE無法使用find */
const IEFind = (items: any, key: number) => {
  const result = items.filter((item: any) => item.p4_node_id === key);
  if (result.length) {
    return result[0];
  }
  return null;
};

@Component
export default class rolePermissionInfo extends Vue {
  @Prop()
  contentSize!: Object;

  @Prop()
  node!: [];

  @Prop()
  role_node_f: any = [];

  private role: any = {}; // 角色的資料

  // 角色的node與權限陣列 **modify格式** 為[[8,4,2,1], [8,4]]

  public loading: boolean = true;

  private dialogRole: boolean = false;

  /** 全選時的動作 */
  private handleAllChange(e: any, index: any) {
    const self = this;
    const ids: number[] = this.node.map((x: any) => x.p4_node_id);
    if (e.target.checked) {
      ids.forEach((id: any) => {
        self.$set(self.role_node_f, id, [4, 8, 2, 1]);
      });
      // return setAll([4, 8, 2, 1]);
    } else {
      ids.forEach((id: any) => {
        self.$set(self.role_node_f, id, []);
      });
    }

    // return setAll([]);

    /** 進行該角色全部節點權限的變更 */
    function setAll(crud: number[]) {
      self.role_node_f.forEach((id: any) => {
        self.$set(self.role_node_f, id, crud);
      });
      // ids.forEach((id) => {
      //   self.$set(self.role_node_f, id, crud);
      // });
    }
  }

  /**
   * 尋找爸爸之旅
   */
  private findPid(pidArr: Array<Number>, PidData: any) {
    // 拿當前nodeID從樹尋找
    if (PidData.p4_node_pid !== null) {
      pidArr.push(PidData.p4_node_pid);
      const PidData2 = this.node.filter(
        (item: any) => item.p4_node_id === PidData.p4_node_pid,
      );
      if (PidData2.length && typeof PidData2[0] === 'object') {
        this.findPid(pidArr, PidData2[0]);
      }
    }
  }

  /**
   * 尋找孩子之旅
   */
  private findChid(chidArr: Array<Number>, Data: any) {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of Data.subs) {
      chidArr.push(item.p4_node_id);
      if (item.subs) {
        this.findChid(chidArr, item);
      }
    }
  }

  /**
   * read crudkey = 4
   */
  private setRead(nodeID: any) {
    const itemData = this.role_node_f[nodeID];

    // 添加值上去
    if (this.hasPermission(itemData, 4)) {
      /** 已有read權限，取消所有權限 */
      this.$set(itemData, 0, undefined);
      this.$set(itemData, 1, undefined);
      this.$set(itemData, 2, undefined);
      this.$set(itemData, 3, undefined);

      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.findChid(chidArr, Data);
      for (const item of chidArr) {
        this.$set(this.role_node_f[item], 0, undefined);
        this.$set(this.role_node_f[item], 1, undefined);
        this.$set(this.role_node_f[item], 2, undefined);
        this.$set(this.role_node_f[item], 3, undefined);
      }
    } else {
      /** 加入權限 */
      this.$set(itemData, 0, 4);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      for (const item of concat) {
        if (!this.role_node_f[item].filter((x: any) => x === 4).length) {
          this.$set(this.role_node_f[item], 0, 4);
        }
      }
    }
  }

  /**
   * create crudKey = 8
   */
  public setCreate(nodeID: any) {
    const itemData = this.role_node_f[nodeID];

    if (this.hasPermission(itemData, 8)) {
      this.$set(itemData, 1, undefined);
      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.findChid(chidArr, Data);
      for (const item of chidArr) {
        this.$set(this.role_node_f[item], 1, undefined);
      }
    } else {
      this.$set(itemData, 0, 4);
      this.$set(itemData, 1, 8);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      for (const item of concat) {
        this.$set(this.role_node_f[item], 0, 4);
        this.$set(this.role_node_f[item], 1, 8);
      }
    }
  }

  /**
   * modify crudkey = 2
   */
  public setModify(nodeID: any, roleId: any) {
    const itemData = this.role_node_f[nodeID];
    if (this.hasPermission(itemData, 2)) {
      this.$set(itemData, 2, undefined);
      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.findChid(chidArr, Data);
      for (const item of chidArr) {
        this.$set(this.role_node_f[item], 2, undefined);
      }
    } else {
      this.$set(itemData, 0, 4);
      this.$set(itemData, 2, 2);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      for (const item of concat) {
        this.$set(this.role_node_f[item], 0, 4);
        this.$set(this.role_node_f[item], 2, 2);
      }
    }
  }

  /**
   * Delete crudKey = 1
   */
  public setDelete(nodeID: any, roleId: any) {
    const itemData = this.role_node_f[nodeID];
    if (this.hasPermission(itemData, 1)) {
      this.$set(itemData, 3, undefined);
      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.findChid(chidArr, Data);
      for (const item of chidArr) {
        this.$set(this.role_node_f[item], 3, undefined);
      }
    } else {
      this.$set(itemData, 0, 4);
      this.$set(itemData, 3, 1);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      for (const item of concat) {
        this.$set(this.role_node_f[item], 0, 4);
        this.$set(this.role_node_f[item], 3, 1);
      }
    }
  }

  /** 檢查是否有該權限存在 */
  private hasPermission(nodeCrud: number[] = [], crud: number): boolean {
    const self = this;
    const exist = nodeCrud.filter((c:any) => c === crud);
    if (exist.length) {
      return true;
    }
    return false;
  }

  // public getInfo() {
  //   this.loading = true;
  //   const getter = new Modify(this.$route.params.p5_role_id);
  //   getter.get().then((d) => {
  //     this.node = d.node_f;
  //     this.role = d.role;
  //     this.role_node_f = d.role_node_f;
  //     this.loading = false;
  //   });
  // }

  /** 送出權限設定，需要由父組件以refs驅動 */
}
